/**
 * _fancybox.js
 * initialize lightbox overlays.
 * http://fancyapps.com/fancybox/3/
 */

import "@fancyapps/fancybox";

const createPhotoGroups = function(){
	let gallery = jQuery('.gallery');

	if(gallery.length == 0)
		return;

	var rel = gallery.attr('id');
	gallery.find(jQuery('.gallery-item a')).each(function(index) {
		jQuery(this).attr('data-fancybox', rel);
	});
}

jQuery(document).ready(function($) {
    createPhotoGroups();

    $('.gallery-item a').fancybox({
        caption : function( instance, item ) {
            return $(this)
                .parents('.gallery-item')
                .find('.gallery-caption')
                .html();
    	}
    });
});
